<template>
  <card-edit v-if="$store.getters.isSettingsReady" @edit="$emit('edit')">
    <order-location :order="$store.getters.orderSystem.order"
                    divider
                    flat
    ></order-location>
  </card-edit>
</template>

<script>
import CardEdit from "@/modules/delivery/components/CardEdit/CardEdit.vue";
import OrderLocation from "@/modules/delivery/components/OrderLocation/OrderLocation.vue";

export default {
  name: "OrderReviewLocation",
  components: {OrderLocation, CardEdit},

}
</script>

<style scoped>

</style>
